<template>
  <v-card>
    <v-card-title></v-card-title>
    <v-card-text class="d-flex flex-column pa-0" style="height: 70vh; align-items: center">
      <PdfPreview v-for="section in sections"
                  :section-id="section.id"></PdfPreview>

<!--      <PdfPreview :section-id="sectionId"></PdfPreview>-->
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="collectHeights"
             large>
        EXPORT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PdfPreview from "@/views/PdfPreview";
import {ACTION_TYPES} from "@/store/types";
import {ref} from "@vue/composition-api/dist/vue-composition-api";
import {onMounted} from "@vue/composition-api";
import _ from "lodash";

export default {
  name: 'AllSectionPreviewModal',
  components: {PdfPreview},
  props: {
    sorId: String,
    volumeId: String,
  },
  setup(props, {root, emit}) {
    const sections = ref([]);
    const getSections = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/section/',
        params: {
          filters: {
            'sor.id': props.sorId,
            'volume.id': props.volumeId,
          },
          page_size: -1,
        },
      });

      if (response.body.success) {
        sections.value = response.body.sections;
      }
    }

    onMounted(()=> {
      getSections();
    })

    const collectHeights = async function () {
      let heights = {
        'sub_section_header': {},
        'sub_section_category_header': {},
        'sub_sub_section': {},
      };
      const targets = [
        {cls: 'pdf-preview-sub-section-header', attribute: 'sub_section_header'},
        {cls: 'pdf-preview-sub-section-category-header', attribute: 'sub_section_category_header'},
        {cls: 'sub-sub-section', attribute: 'sub_sub_section'},
      ];

      targets.forEach((a) => {
        let elements = [...document.body.getElementsByClassName(a.cls)];

        elements.forEach((e) => {
          heights[a.attribute][e.id] = e.offsetHeight;
        })
      });

      // console.log(heights);

      let sub_sections = {};
      _.forEach(heights.sub_section_header, (value, key) => {
        sub_sections[key] = {
          header: value,
          category: heights.sub_section_category_header[key]
        };
      })

      let sub_sub_sections = {};
      _.forEach(heights.sub_sub_section, (value, key) => {
        sub_sub_sections[key] = value + 16;
      })

      let params = {
        sub_sections,
        sub_sub_sections,
      }

      // console.log(params);

      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/section/set_heights/',
        params,
      });

      if (response.body.success) {
        for (let i=0; i< sections.value.length; i++) {
          let section = sections.value[i];
          await root.$store.dispatch(ACTION_TYPES.CALL_API, {
            url: 'admin/section/export_pdf/',
            params: {
              section_id: section.id,
            },
            opt: {extra: {responseType: 'arraybuffer'}},
          });
        }

        emit('submit', true);
      }
    }

    return {
      sections,
      collectHeights,
    }
  }
}
</script>
